import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { FormGroup, Row, Col } from "reactstrap";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import InputLabel from '@mui/material/InputLabel'
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker,
// } from "@mui/material/pickers";
import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import FileBase64 from "../../components/Upload/UploadFile";
import { dealerWithdrawEMoneyList } from "../../redux/actions/dealerGetWithdrawEMoneyListAction";
import { dealerReqWithdrawEMoney } from "../../redux/actions/dealerReqWithdrawEMoneyAction";
import { dealerCashLiftingList } from "../../redux/actions/dealerCashLiftingListAction";
import { dealerReqCashLifting } from "../../redux/actions/dealerReqCashLiftingAction";
import { dealerBankName } from "../../redux/actions/dealerBankNameAction";
import { dealerBranchName } from "../../redux/actions/dealerBranchNameAction";
import Util from "../../validation/index";
import { countries } from "../../utils/countriesDropdown";
import { dealerGetUserMasterList } from "../../redux/actions/dealerGetUserMasterListAction";
import { dealerViewUserMaster } from "../../redux/actions/dealerViewUserMasterAction";
import { dealerDeleteUserMaster } from "../../redux/actions/dealerDeleteUserMasterAction";
import { dealerBlockUnblockUser } from "../../redux/actions/dealerBlockUnblockUserAction";
import { dealerAddEditUserMaster } from "../../redux/actions/dealerAddEditUserMasterAction";
import { dealerAddUpdateDivisonList } from '../../redux/actions/dealerAddUpdateDivisionListAction';
import { dealerAddUpdateDistrictList } from "../../redux/actions/dealerAddUpdateDistrictListAction";
import { dealerAddUpdateThanaList } from '../../redux/actions/dealerAddUpdateThanaListAction';
import { dealerAddUpdateUnionList } from '../../redux/actions/dealerAddUpdateUnionListAction';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function DealerBackOffice() {
    const navigate = useHistory();
    const [addNotification, setAddNotification] = useState(false)
    const [editNotification, setEditNotification] = useState(false)
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [deleteNotification, setDeleteNotification] = useState(false)
    const [blockUnblockUser, setBlockUnblockUser] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [addOpen, setAddOpen] = useState(false)
    const [viewOpen, setViewOpen] = useState(false)
    const [editOpen, setEditOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [addEditOpen, setAddEditOpen] = useState(false)

    const [deleteUserMaster, setDeleteUserMaster] = useState("")

    const [userId, setUserId] = useState("")

    const [hiddenPassword, setHiddenPassword] = useState("true");
    const [hiddenConPassword, setHiddenConPassword] = useState("true");

    const [userMasterListStatus, setUserMasterListStatus] = useState(false)
    const [userMasterListArray, setUserMasterListArray] = useState("")

    const [addEditUserStatus, setAddEditUserStatus] = useState(false)
    const [addEditUserArray, setAddEditUserArray] = useState("")

    const [viewUserMasterStatus, setViewUserMasterStatus] = useState(false)
    const [viewUserMasterArray, setViewUserMasterArray] = useState("")

    const [deleteUserMasterStatus, setDeleteUserMasterStatus] = useState(false)
    const [deleteUserMasterArray, setDeleteUserMasterArray] = useState("")

    const [blockUnblockUserStatus, setBlockUnblockUserStatus] = useState(false)
    const [blockUnblockUserArray, setBlockUnblockUserArray] = useState("")

    const [withdrawEMoneyListStatus, setWithdrawEMoneyListStatus] = useState(false)
    const [withdrawEMoneyListArray, setWithdrawEMoneyListArray] = useState("")

    const [cashLiftingListStatus, setCashLiftingListStatus] = useState(false)
    const [cashLiftingListArray, setCashLiftingListArray] = useState("")

    const [reqWithdrawEMoneyStatus, setReqWithdrawEMoneyStatus] = useState(false)
    const [reqWithdrawEMoneyArray, setReqWithdrawEMoneyArray] = useState("")

    // const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();


    const [UploadFileName, setUploadFileName] = useState("");
    const [uploadFile, setUploadFile] = useState("");

    const [requestInput, setRequestInput] = useState({
        userName: "",
        password: "",
        cnfmPassword: "",
        role: "",
        fullName: "",
        email: "",
        phoneNo: "",
        companyName: "",
        address: "",
        country: "",
        state: "",
        city: "",
        postalCode: "",
        division: "",
        district: "",
        thana: "",
        union: "",
        regionId: "",
        areaId: ""
    })

    const {
        userName,
        password,
        cnfmPassword,
        role,
        fullName,
        email,
        phoneNo,
        companyName,
        address,
        country,
        state,
        city,
        postalCode,
        division,
        district,
        thana,
        union,
        regionId,
        areaId
    } = requestInput

    const onInputChangeMod = ({ target: { name, value } }, type) => {
        const obj = {
            ...requestInput,
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else if (type) {
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        } else {
            obj[name] = value
        }
        setRequestInput(obj);
    };

    const [user, setUser] = useState({
        nameSearch: "",
        userNameSearch: "",
        bankNameSearch: "",
        branchNameSearch: "",
        getStatus: ""
    });

    const {
        nameSearch,
        userNameSearch,
        bankNameSearch,
        branchNameSearch,
        getStatus
    } = user;

    const onInputChange = ({ target: { name, value } }, type) => {
        const obj = {
            ...user,
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setUser(obj);
    };

    const setDivisionList = useSelector(
        ({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
    )

    const setDistrictList = useSelector(
        ({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
    )

    const setThanaList = useSelector(
        ({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
    )

    const setUnionList = useSelector(
        ({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
    )

    const getUserMasrterListRes = useSelector(
        ({ dealerGetUserMasterList }) => dealerGetUserMasterList
    )

    const addEditUserRes = useSelector(
        ({ dealerAddEditUserMaster }) => dealerAddEditUserMaster
    )

    const viewUserMasterRes = useSelector(
        ({ dealerViewUserMaster }) => dealerViewUserMaster
    )

    const deleteUserMasterRes = useSelector(
        ({ dealerDeleteUserMaster }) => dealerDeleteUserMaster
    )

    const blockUnblockUserRes = useSelector(
        ({ dealerBlockUnblockUser }) => dealerBlockUnblockUser
    )

    const cashLiftingListRes = useSelector(
        ({ dealerCashLiftingList }) => dealerCashLiftingList
    )

    const withdrawEMoneyListRes = useSelector(
        ({ dealerGetWithdrawEMoneyList }) => dealerGetWithdrawEMoneyList
    )

    const reqWithdrawEMoneyRes = useSelector(
        ({ dealerReqWithdrawEMoney }) => dealerReqWithdrawEMoney
    )

    const setAddUpdateDivisionListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",


            }
        }
        dispatch(dealerAddUpdateDivisonList(req, authToken))
    }

    const setAddUpdateDistrictListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: division

            }
        }
        dispatch(dealerAddUpdateDistrictList(req, authToken))
    }

    useEffect(() => {
        if (division) {
            setAddUpdateDistrictListReq()
        }
    }, [division])

    const setAddUpdateThanaListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: division

            }
        }
        dispatch(dealerAddUpdateThanaList(req, authToken))
    }

    useEffect(() => {
        if (division) {
            setAddUpdateThanaListReq()
        }
    }, [division])

    const setAddUpdateUnionListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: division,
                thana: thana

            }
        }
        dispatch(dealerAddUpdateUnionList(req, authToken))
    }


    useEffect(() => {
        if (division && thana) {
            setAddUpdateUnionListReq()
        }
    }, [division, thana])

    const userMasterListReq = () => {
        setUserMasterListStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                userName: userNameSearch,
                ratName: nameSearch,
                isAccountLocked: getStatus === 'All' ? '' : getStatus,
            }
        }
        dispatch(dealerGetUserMasterList(req, authToken))
    }

    const userMasterListFunc = () => {
        if (userMasterListStatus) {
            if (getUserMasrterListRes.data.status == "success") {
                setUserMasterListArray([].concat(getUserMasrterListRes.data.ratList))
                setIsLoading(false)
            }
            if (getUserMasrterListRes.data.status == "failed") {
                setUserMasterListArray(getUserMasrterListRes.data)
                setIsLoading(false)
            }
            if (getUserMasrterListRes.data.status == "NOT FOUND") {
                setUserMasterListArray(getUserMasrterListRes.data)
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        userMasterListFunc()
    }, [getUserMasrterListRes.data.status])

    const addEditUserReq = () => {
        setAddEditUserStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                ratId: userId,
                userName: userName,
                password: password,
                role: role,
                fullName: fullName,
                email: email,
                mobileNumber: phoneNo,
                companyName: companyName,
                address: address,
                country: country,
                division: division,
                district: district,
                thana: thana,
                union: union,
                postalCode: postalCode,
                regionId: 2,
                areaId: 2,
                state: state,
                city: city

            }

        }
        // console.log("updatttteee", req)
        dispatch(dealerAddEditUserMaster(req, authToken))
        setAddOpen(false)
    }



    const addEditUserFunc = () => {
        if (addEditUserStatus) {
            if (addEditUserRes.data.status == "success") {
                setAddEditUserArray(addEditUserRes.data)
                setAddEditOpen(true)
                userMasterListReq()
            }
            if (addEditUserRes.data.status == "failed") {
                setAddEditUserArray(addEditUserRes.data)
                setAddEditOpen(true)
            }
        }
    }

    useEffect(() => {
        addEditUserFunc()
    }, [addEditUserRes.data.status])

    const viewUserMasterReq = (id, type) => {
        setViewUserMasterStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                ratId: id
            }
        }
        dispatch(dealerViewUserMaster(req, authToken))
        if (type == "view") {
            setViewOpen(true)
        }
        if (type == "edit") {
            setEditOpen(true)
            setUserId(id)
        }
    }

    const viewUserMasterFunc = () => {
        if (viewUserMasterStatus) {
            if (viewUserMasterRes.data.status == "success") {
                setViewUserMasterArray(viewUserMasterRes.data.viewMgtList)
            }
            if (viewUserMasterRes.data.status == "failed") {
                setViewUserMasterArray(viewUserMasterRes.data)
            }
        }
    }

    useEffect(() => {
        viewUserMasterFunc()
    }, [viewUserMasterRes.data.status])

    useEffect(() => {
        if (viewUserMasterRes.data.status == "success") {
            setRequestInput({
                userName: viewUserMasterArray.userName,
                // password: viewUserMasterArray.password,
                // cnfmPassword: viewUserMasterArray.,
                role: viewUserMasterArray.role,
                fullName: viewUserMasterArray.fullName,
                email: viewUserMasterArray.email,
                phoneNo: viewUserMasterArray.phoneNo,
                address: viewUserMasterArray.address,
                country: viewUserMasterArray.country,
                division: viewUserMasterArray.division,
                district: viewUserMasterArray.district,
                thana: viewUserMasterArray.thana,
                union: viewUserMasterArray.union,
                city: viewUserMasterArray.city,
                state: viewUserMasterArray.state,
                companyName: viewUserMasterArray.companyName,
                postalCode: viewUserMasterArray.postalCode,
            })
        }
    }, [viewUserMasterArray])

    const deleteUserFunc = (value) => {
        setDeleteUserMaster(value);
        setEditOpen(false);
        setViewOpen(false)
        setAddOpen(false)
        setDeleteOpen(true);
    };

    const deleteUserMasterReq = () => {
        setDeleteUserMasterStatus(true)
        setViewOpen(false);
        setEditOpen(false);
        setAddOpen(false);
        setDeleteOpen(false)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                ratId: deleteUserMaster
            }
        }
        dispatch(dealerDeleteUserMaster(req, authToken))
    }

    const deleteUserMasterFunc = () => {
        if (deleteUserMasterStatus) {
            if (deleteUserMasterRes.data.status == "success") {
                setDeleteUserMasterArray(deleteUserMasterRes.data)
                setDeleteNotification(true)
                userMasterListReq()
            }
            if (deleteUserMasterRes.data.status == "failed") {
                setDeleteUserMasterArray(deleteUserMasterRes.data)
                setDeleteNotification(true)
            }
        }
    }

    useEffect(() => {
        deleteUserMasterFunc()
    }, [deleteUserMasterRes.data.status])

    const blockUnblockUserReq = (type, id) => {
        setBlockUnblockUserStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                action: type,
                isAccountLocked: type == "block" ? 0 : 1,
                ratId: id
            }
        }
        dispatch(dealerBlockUnblockUser(req, authToken))
    }

    const blockUnblockUserFunc = () => {
        if (blockUnblockUserStatus) {
            if (blockUnblockUserRes.data.status == "success") {
                setBlockUnblockUserArray(blockUnblockUserRes.data)
                setBlockUnblockUser(true)
                userMasterListReq()
            }
            if (blockUnblockUserRes.data.status == "failed") {
                setBlockUnblockUserArray(blockUnblockUserRes.data)
                setBlockUnblockUser(true)
            }
        }
    }

    useEffect(() => {
        blockUnblockUserFunc()
    }, [blockUnblockUserRes.data.status])

    const withdrawEMoneyListReq = () => {
        setWithdrawEMoneyListStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                bankName: bankNameSearch,
                branchName: branchNameSearch
            }
        }
        dispatch(dealerWithdrawEMoneyList(req, authToken))
    }

    const withdrawEMoneyListFunc = () => {
        if (withdrawEMoneyListStatus) {
            if (withdrawEMoneyListRes.data.status == "success") {
                setWithdrawEMoneyListArray(withdrawEMoneyListRes.data.errorList)
                setIsLoading(false)
            }
            if (withdrawEMoneyListRes.data.status == "failed") {
                setWithdrawEMoneyListArray(withdrawEMoneyListRes.data)
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        withdrawEMoneyListFunc()
    }, [withdrawEMoneyListRes.data.status])

    // const reqWithdrawEMoneyReq = () => {
    //     setReqWithdrawEMoneyStatus(true)
    //     let req = {
    //         actionCustomerMasterRequestVO: {
    //             dealerId: regenerateTokenRes.data.partnerId,
    //             bankName: bankName,
    //             branchName: branchName,
    //             accountNumber: accountNum,
    //             amount: amount,
    //             accountType: accountType
    //         }
    //     }
    //     dispatch(dealerReqWithdrawEMoney(req, authToken))
    //     setAddOpen(false)
    // }

    const reqWithdrawEMoneyFunc = () => {
        if (reqWithdrawEMoneyStatus) {
            if (reqWithdrawEMoneyRes.data.status == "success") {
                setReqWithdrawEMoneyArray(reqWithdrawEMoneyRes.data)
                withdrawEMoneyListReq()
                setEditNotification(true)
            }
            if (reqWithdrawEMoneyRes.data.status == "failed") {
                setReqWithdrawEMoneyArray(reqWithdrawEMoneyRes.data)
                setEditNotification(true)

            }

        }
    }

    useEffect(() => {
        reqWithdrawEMoneyFunc()
    }, [reqWithdrawEMoneyRes.data.status])

    useEffect(() => {
        console.log(country, "////////////////////////////////////////")
    }, [country])

    const bankNameReq = () => {
        let req = {
            actionCustomerMasterRequestVO: {

                dealerId: regenerateTokenRes.data.partnerId
            }
        }

        dispatch(dealerBankName(req, authToken))
    }

    // const branchNameReq = () => {
    //     let req = {
    //         actionCustomerMasterRequestVO: {

    //             dealerId: regenerateTokenRes.data.partnerId,
    //             bankCode: bankName
    //         }
    //     }

    //     dispatch(dealerBranchName(req, authToken))
    // }

    // useEffect(() => {
    //     branchNameReq()
    // }, [bankName, bankNameSearch])

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            // withdrawEMoneyListReq()
            // bankNameReq()
            setAddUpdateDivisionListReq()
            userMasterListReq()
        }
    }, [regenerateTokenRes.data.status])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleClose = () => {
        setAddOpen(false)
        setViewOpen(false)
        setEditOpen(false)
        setDeleteOpen(false)
        setRequestInput({
            userName: "",
            password: "",
            cnfmPassword: "",
            role: "",
            fullName: "",
            email: "",
            phoneNo: "",
            companyName: "",
            address: "",
            country: "",
            state: "",
            city: "",
            postalCode: "",
            division: "",
            district: "",
            thana: "",
            union: "",

        })
        // console.log("bbbbbb", setRequestInput)
    }

    const openAdd = () => {
        setAddOpen(true)
    }

    const handleNoticationClose = () => {
        setNotificationOpen(false);
        setAddNotification(false)
        setEditNotification(false)
        setDeleteNotification(false)
        setBlockUnblockUser(false)
        setAddEditOpen(false)
    };

    const togglePassword = (e) => {
        e.preventDefault();
        setHiddenPassword((state) => !state);
    };

    const toggleConPassword = (e) => {
        e.preventDefault();
        setHiddenConPassword((state) => !state);
    };

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center",
                        }}
                    >
                        <Grid item xs={12} md={8} sm={3} lg={8}></Grid>
                        <Grid item xs={12} md={4} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={() => openAdd()}
                            >
                                Add New User
                            </CustomButton>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4} >
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Name"
                                fullWidth={true}
                                name="nameSearch"
                                value={nameSearch || ""}
                                onChange={(e) => onInputChange(e, "alphabet")}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="User Name"
                                fullWidth={true}
                                name="userNameSearch"
                                value={userNameSearch || ""}
                                onChange={(e) => onInputChange(e, "alphabet")}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                autoFocus

                                // id="name"
                                label="Status"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="getStatus"

                                // value={getStatus || ""}
                                defaultValue={getStatus || "All"}

                                // onChange={handleChange}
                                onChange={(e) => onInputChange(e)}
                            >
                                <MenuItem value="All" selected="">
                                    All
                                </MenuItem>
                                <MenuItem value="1">Block</MenuItem>
                                <MenuItem value="0">Unblock</MenuItem>

                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={userMasterListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : userMasterListArray.length == undefined ||
                    !userMasterListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px",
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="themeBackground">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    User ID	{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    User Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mobile
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Role
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {userMasterListArray &&
                                                []
                                                    .concat(userMasterListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.customerId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.name}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.userName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.mobile}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.role}
                                                            </TableCell>
                                                            <TableCell
                                                                align="center"
                                                            >
                                                                <Tooltip title="View">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => viewUserMasterReq(row.customerId, "view")}
                                                                    >
                                                                        {
                                                                            <VisibilityIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>

                                                                <Tooltip title="Edit">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => viewUserMasterReq(row.customerId, "edit")}
                                                                    >
                                                                        {
                                                                            <EditIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>

                                                                <Tooltip title="Delete">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() =>
                                                                            deleteUserFunc(row.customerId)
                                                                        }
                                                                    >
                                                                        {
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                                {row.isAccLocked == 0 ?
                                                                    (<CustomButton
                                                                        style={{
                                                                            padding: "10px"
                                                                        }}
                                                                        onClick={() =>
                                                                            blockUnblockUserReq("block", row.customerId)
                                                                        }
                                                                    >
                                                                        Block
                                                                    </CustomButton>)
                                                                    : (<CustomButton
                                                                        style={{
                                                                            padding: "10px"
                                                                        }}
                                                                        onClick={() =>
                                                                            blockUnblockUserReq("unblock", row.customerId)
                                                                        }
                                                                    >
                                                                        Unblock
                                                                    </CustomButton>)}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(userMasterListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
            </Layout>

            <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle>Add New User</DialogTitle>
                    <DialogContent>
                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                required
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Username"
                                fullWidth={true}
                                name="userName"
                                value={userName || ""}
                                onChange={(e) => onInputChangeMod(e, "alphabet")}
                            />
                        </div>
                        {/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  required
                  helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
                  type="password"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Password"
                  fullWidth={true}
                  name="password"
                  value={password || ""}
                  // onChange={handleChange}
                />
              </div> */}

                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <FormGroup>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
                                        type={hiddenPassword ? "password" : "text"}
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Password"
                                        fullWidth={true}
                                        name="password"
                                        id="password"
                                        value={password}
                                        onChange={(e) => onInputChangeMod(e)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={togglePassword}
                                                        onMouseDown={togglePassword}
                                                    >
                                                        {hiddenPassword ? (
                                                            <VisibilityOff />
                                                        ) : (
                                                            <Visibility />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                            </FormGroup>
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <FormGroup>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        helperText="(Should be same as Password)"
                                        type={hiddenConPassword ? "password" : "text"}
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Confirm Password"
                                        fullWidth={true}
                                        name="cnfmPassword"
                                        id="cnfmPassword"
                                        value={cnfmPassword}
                                        onChange={(e) => onInputChangeMod(e)}
                                        error={
                                            password &&
                                                password !== cnfmPassword &&
                                                cnfmPassword ? (
                                                <p
                                                    className="passwordNotMatch"
                                                    style={{ color: "red" }}
                                                >
                                                    {"Password did not match"}
                                                </p>
                                            ) : (
                                                ""
                                            )
                                        }
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={toggleConPassword}
                                                        onMouseDown={toggleConPassword}
                                                    >
                                                        {hiddenConPassword ? (
                                                            <VisibilityOff />
                                                        ) : (
                                                            <Visibility />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                            </FormGroup>
                        </div>
                        {/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  required
                  helperText="(Should be same as PASSWORD)"
                  type="password"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Confirm Password"
                  fullWidth={true}
                  name="cnfmPassword"
                  value={cnfmPassword || ""}
                  // onChange={handleChange}
                />
              </div> */}
                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Role"
                                fullWidth={true}
                                name="role"
                                defaultValue={role || "Select Role"}
                                onChange={(e) => onInputChangeMod(e)}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                <MenuItem value="SubOwner">SubOwner</MenuItem>
                                {/* <MenuItem value="Cashier">Cashier</MenuItem> */}
                                <MenuItem value="Dealer">Dealer</MenuItem>

                            </TextField>
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                required
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Full Name"
                                fullWidth={true}
                                name="fullName"
                                value={fullName || ""}
                                onChange={(e) => onInputChangeMod(e, "alphabet")}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Email"
                                fullWidth={true}
                                name="email"
                                value={email || ""}
                                onChange={(e) => onInputChangeMod(e)}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Phone Number"
                                fullWidth={true}
                                name="phoneNo"
                                value={phoneNo || ""}
                                onChange={(e) => onInputChangeMod(e, "number")}
                            ></TextField>
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                required
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Address"
                                fullWidth={true}
                                name="address"
                                value={address || ""}
                                onChange={(e) => onInputChangeMod(e)}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="string"
                                label="Country"
                                fullWidth={true}
                                name="country"
                                // value={country}
                                value={country || "Select Country"}
                                onChange={(e) => onInputChangeMod(e)}
                            >
                                <MenuItem value="Select Country" selected="Select Country">
                                    Select Country
                                </MenuItem>

                                {countries.map((x) => (
                                    <MenuItem value={x.label}>
                                        {x.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>

                        {country == "Bangladesh" &&
                            (<>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Division"
                                        fullWidth={true}
                                        name="division"
                                        defaultValue={division || "Select Divison"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Divison" selected="Select Divison">
                                            Select Division
                                        </MenuItem>
                                        {/* {setDivisionList.success} */}
                                        {setDivisionList.success &&
                                            setDivisionList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="District"
                                        fullWidth={true}
                                        name="district"
                                        defaultValue={district || "Select District"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select District" selected="Select District">
                                            Select District
                                        </MenuItem>
                                        {setDistrictList.success &&
                                            setDistrictList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Thana/Upazilla"
                                        fullWidth={true}
                                        name="thana"
                                        defaultValue={thana || "Select Thana/Upazilla"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                            Select Thana/Upazilla
                                        </MenuItem>

                                        {setThanaList.success &&
                                            setThanaList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Union/Ward"
                                        fullWidth={true}
                                        name="union"
                                        defaultValue={union || "Select Union/Ward"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                            Select Union/Ward
                                        </MenuItem>
                                        {setUnionList.success &&
                                            setUnionList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div></>)}

                        {country !== "Bangladesh" && (
                            <>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="State"
                                        fullWidth={true}
                                        name="state"
                                        value={state || ""}
                                        onChange={(e) => onInputChangeMod(e)}
                                    />
                                </div>

                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="City"
                                        fullWidth={true}
                                        name="city"
                                        value={city || ""}
                                        onChange={(e) => onInputChangeMod(e)}
                                    />
                                </div>

                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Postal Code"
                                        fullWidth={true}
                                        name="postalCode"
                                        value={postalCode || ""}
                                        onChange={(e) => onInputChangeMod(e, "number")}
                                    />
                                </div>
                            </>
                        )}

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px",
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                            }}
                            onClick={addEditUserReq}
                        >
                            Add
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={viewOpen} onClose={handleClose}>
                    <DialogTitle>View User</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            required
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Username"
                            fullWidth={true}
                            name="userName"
                            value={userName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            required
                            select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="role"
                            value={role || "Select Role"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem value="Select Role" selected="Select Role">
                                Select Role
                            </MenuItem>
                            <MenuItem value="SubOwner">SubOwner</MenuItem>
                            {/* <MenuItem value="Cashier">Cashier</MenuItem> */}
                            <MenuItem value="Dealer">Dealer</MenuItem>

                        </TextField>
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            required
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Full Name"
                            fullWidth={true}
                            name="fullName"
                            value={fullName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Email"
                            fullWidth={true}
                            name="email"
                            value={email || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Phone Number"
                            fullWidth={true}
                            name="phoneNo"
                            value={phoneNo || ""}
                            onChange={(e) => onInputChangeMod(e, "number")}
                        ></TextField>
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            required
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Address"
                            fullWidth={true}
                            name="address"
                            value={address || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        {" "}
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            required
                            select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="string"
                            label="Country"
                            fullWidth={true}
                            name="country"
                            // value={country}
                            value={country || "Select Country"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem value="Select Country" selected="Select Country">
                                Select Country
                            </MenuItem>

                            {countries.map((x) => (
                                <MenuItem value={x.label}>
                                    {x.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        {/* <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="State"
                            fullWidth={true}
                            name="state"
                            value={state || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="City"
                            fullWidth={true}
                            name="city"
                            value={city || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            disabled
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Postal Code"
                            fullWidth={true}
                            name="postalCode"
                            value={postalCode || ""}
                            onChange={(e) => onInputChangeMod(e, "number")}
                        /> */}
                        {country == "Bangladesh" &&
                            (<>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        // select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Division"
                                        fullWidth={true}
                                        name="division"
                                        defaultValue={division || "Select Divison"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Divison" selected="Select Divison">
                                            Select Division
                                        </MenuItem>
                                        {setDivisionList.success &&
                                            setDivisionList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        // select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="District"
                                        fullWidth={true}
                                        name="district"
                                        defaultValue={district || "Select District"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select District" selected="Select District">
                                            Select District
                                        </MenuItem>
                                        {setDistrictList.success &&
                                            setDistrictList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        // select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Thana/Upazilla"
                                        fullWidth={true}
                                        name="thana"
                                        defaultValue={thana || "Select Thana/Upazilla"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                            Select Thana/Upazilla
                                        </MenuItem>

                                        {setThanaList.success &&
                                            setThanaList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        // select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Union/Ward"
                                        fullWidth={true}
                                        name="union"
                                        defaultValue={union || "Select Union/Ward"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                            Select Union/Ward
                                        </MenuItem>
                                        {setUnionList.success &&
                                            setUnionList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div></>)}

                        {country !== "Bangladesh" && (
                            <>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="State"
                                        fullWidth={true}
                                        name="state"
                                        value={state || ""}
                                        onChange={(e) => onInputChangeMod(e)}
                                    />
                                </div>

                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="City"
                                        fullWidth={true}
                                        name="city"
                                        value={city || ""}
                                        onChange={(e) => onInputChangeMod(e)}
                                    />
                                </div>

                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        disabled
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Postal Code"
                                        fullWidth={true}
                                        name="postalCode"
                                        value={postalCode || ""}
                                        onChange={(e) => onInputChangeMod(e, "number")}
                                    />
                                </div>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px",
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Edit User</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            required
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Username"
                            fullWidth={true}
                            name="userName"
                            value={userName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            required
                            select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="role"
                            value={role || "Select Role"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem value="Select Role" selected="Select Role">
                                Select Role
                            </MenuItem>
                            <MenuItem value="SubOwner">SubOwner</MenuItem>
                            {/* <MenuItem value="Cashier">Cashier</MenuItem> */}
                            <MenuItem value="Dealer">Dealer</MenuItem>

                        </TextField>
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            required
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Full Name"
                            fullWidth={true}
                            name="fullName"
                            value={fullName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Email"
                            fullWidth={true}
                            name="email"
                            value={email || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Phone Number"
                            fullWidth={true}
                            name="phoneNo"
                            value={phoneNo || ""}
                            onChange={(e) => onInputChangeMod(e, "number")}
                        ></TextField>
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            required
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Address"
                            fullWidth={true}
                            name="address"
                            value={address || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        {" "}
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            required
                            select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="string"
                            label="Country"
                            fullWidth={true}
                            name="country"
                            // value={country}
                            value={country || "Select Country"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem value="Select Country" selected="Select Country">
                                Select Country
                            </MenuItem>

                            {countries.map((x) => (
                                <MenuItem value={x.label}>
                                    {x.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        {/* <TextField
                            style={{ marginTop: "1.5rem" }}
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="State"
                            fullWidth={true}
                            name="state"
                            value={state || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="City"
                            fullWidth={true}
                            name="city"
                            value={city || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        />
                        <TextField
                            style={{ marginTop: "1.5rem" }}
                            type="text"
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Postal Code"
                            fullWidth={true}
                            name="postalCode"
                            value={postalCode || ""}
                            onChange={(e) => onInputChangeMod(e, "number")}
                        /> */}

                        {country == "Bangladesh" &&
                            (<>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Division"
                                        fullWidth={true}
                                        name="division"
                                        defaultValue={division || "Select Divison"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Divison" selected="Select Divison">
                                            Select Division
                                        </MenuItem>
                                        {/* {setDivisionList.success} */}
                                        {setDivisionList.success &&
                                            setDivisionList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="District"
                                        fullWidth={true}
                                        name="district"
                                        defaultValue={district || "Select District"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select District" selected="Select District">
                                            Select District
                                        </MenuItem>
                                        {setDistrictList.success &&
                                            setDistrictList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Thana/Upazilla"
                                        fullWidth={true}
                                        name="thana"
                                        defaultValue={thana || "Select Thana/Upazilla"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                            Select Thana/Upazilla
                                        </MenuItem>

                                        {setThanaList.success &&
                                            setThanaList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        select
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Union/Ward"
                                        fullWidth={true}
                                        name="union"
                                        defaultValue={union || "Select Union/Ward"}
                                        onChange={(e) => onInputChangeMod(e)}
                                    >
                                        <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                            Select Union/Ward
                                        </MenuItem>
                                        {setUnionList.success &&
                                            setUnionList.data.list.map((x) => (
                                                <MenuItem value={x.name}>{x.name}</MenuItem>
                                            ))}
                                    </TextField>
                                </div></>)}

                        {country !== "Bangladesh" && (
                            <>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="State"
                                        fullWidth={true}
                                        name="state"
                                        value={state || ""}
                                        onChange={(e) => onInputChangeMod(e)}
                                    />
                                </div>

                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="City"
                                        fullWidth={true}
                                        name="city"
                                        value={city || ""}
                                        onChange={(e) => onInputChangeMod(e)}
                                    />
                                </div>

                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Postal Code"
                                        fullWidth={true}
                                        name="postalCode"
                                        value={postalCode || ""}
                                        onChange={(e) => onInputChangeMod(e, "number")}
                                    />
                                </div>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px",
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                            }}
                            onClick={addEditUserReq}
                        >
                            Edit
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={deleteOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                    <DialogActions className="p-3">
                        <Button
                            style={{
                                backgroundColor: "#fff",
                                color: "#000"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={deleteUserMasterReq}
                        >
                            Yes
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {addEditUserRes.data.status == "success" && (
                <div>
                    <Dialog open={addEditOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addEditUserArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addEditUserRes.data.status == "failed" && (
                <div>
                    <Dialog open={addEditOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addEditUserArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {deleteUserMasterRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteUserMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {deleteUserMasterRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteUserMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {blockUnblockUserRes.data.status == "success" && (
                <div>
                    <Dialog open={blockUnblockUser} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {blockUnblockUserArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {blockUnblockUserRes.data.status == "failed" && (
                <div>
                    <Dialog open={blockUnblockUser} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {blockUnblockUserArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    );
}

export default DealerBackOffice;